
import { useEffect, useState } from "react";
import useProjects from "../../../hooks/useProjects";
import { FilledButton, OutlinedButton } from "../../common/Button";
import Lightbox from "../../common/Lightbox";
import useDisplayNotifications from "../../../hooks/useDisplayNotifications";
import { DisplayNotificationType } from "../../../models/DisplayNotification";
import useMyProjects from "../../../hooks/useMyProjects";
import TextInputArea from "../../common/TextInputArea";
import useProjectManagement from "../../../hooks/useProjectManagement";
import { ETaskStatus, ITask } from "../../../data_models/task";
import useTasks from "../../../hooks/useTasks";
import useConfig from "../../../hooks/useConfig";


interface RequestTaskCompletionProps {
    onClose: () => void;
    task: ITask;
    onUpdateTask: (updatedTask: ITask) => void;
}

const RequestTaskCompletion: React.FC<RequestTaskCompletionProps> = ({ onClose, task, onUpdateTask }) => {

    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');

    const { updateStatus } = useTasks();
    const { config } = useConfig();

    const { addSuccessNotification, addErrorNotification } = useDisplayNotifications();

    const onRequestCompletion = async () => {
        setLoading(true);
        try {
            const updatedTask = await updateStatus(task._id!, ETaskStatus.REQUESTED_COMPLETION);
            onUpdateTask(updatedTask);
            addSuccessNotification(`Successfully requested completion for ${task.title}.`);
        } catch (error: any) {
            addErrorNotification(error.message, "Could not request completion");
        }
        setLoading(false);
        onClose();
    }

    return (
        <Lightbox
            header="Request Completion"
            onCancel={onClose}
            onConfirm={onRequestCompletion}
            loadingConfirm={loading}
            content={
                <p>Once you confirm, the client will be notified to review and confirm the task. We'll let them know it’s ready!</p>
            }
            onClose={onClose}
        />

    );
}

export default RequestTaskCompletion;